import { Component } from 'react';
import { connect } from 'react-redux';
import { asField } from 'informed';
import { Icon } from 'components/common/icons';

const SettingsPicturePosition = connect((state) => ({
  theme: state.theme
}))(
  asField(
    class extends Component {
      state = {
        position: this.props.fieldState.value
          ? this.props.fieldState.value
          : null
      };

      componentDidUpdate() {
        if (
          this.props.fieldState.value &&
          this.state.position &&
          this.props.fieldState.value !== this.state.position
        ) {
          this.setState({ position: this.props.fieldState.value });
        }
      }

      handleClick = (ev) => {
        const position = ev.currentTarget.getAttribute('data-position');
        this.setState({ position });
        this.props.fieldApi.setValue(position);
        if (this.props.onChange) this.props.onChange(position);
      };

      render() {
        const { theme } = this.props;
        const { position } = this.state;

        const options = [
          { value: 'left top', icon: 'long-arrow-alt-left', rotate: 45 },
          { value: 'center top', icon: 'long-arrow-alt-left', rotate: 90 },
          { value: 'right top', icon: 'long-arrow-alt-left', rotate: 135 },
          { value: 'left center', icon: 'long-arrow-alt-left', rotate: 0 },
          { value: 'center center', icon: 'arrows-alt', rotate: 0 },
          { value: 'right center', icon: 'long-arrow-alt-left', rotate: 180 },
          { value: 'left bottom', icon: 'long-arrow-alt-left', rotate: 315 },
          { value: 'center bottom', icon: 'long-arrow-alt-left', rotate: 270 },
          { value: 'right bottom', icon: 'long-arrow-alt-left', rotate: 225 }
        ];

        return (
          <div className="options">
            {options.map((option, i) => (
              <button
                className={`button ${
                  position === option.value ? 'active' : ''
                }`}
                data-position={option.value}
                key={i}
                onClick={this.handleClick}
                type="button"
              >
                <Icon
                  icon={option.icon}
                  transform={{ rotate: option.rotate }}
                />
              </button>
            ))}

            <style jsx>{`
              .options {
                display: flex;
                gap: 10px;
              }
              .button {
                background-color: ${theme.lightGrey};
                border: 0;
                border-radius: ${theme.buttonBorderRadius};
                box-shadow: 0 0 0 2px white;
                color: ${theme.textColorLighter};
                cursor: pointer;
                font-size: 1.5rem;
                height: 32px;
                outline: 0;
                padding: 5px 0;
                transition: box-shadow 0.2s;
                width: 32px;
              }
              .button:focus,
              .button:hover {
                box-shadow: 0 0 0 2px ${theme.lightGreyDark};
              }
              .button.active {
                box-shadow: 0 0 0 2px ${theme.textColorLighter};
              }
            `}</style>
          </div>
        );
      }
    }
  )
);

export default SettingsPicturePosition;
